import type { Order } from '@team-milva/lab-models/resources'

// Which tab of the orders list an order belongs to. Two independent facts decide it:
// `statuses.orderStatus === 'draft'` (not placed yet) and `activeState` (the customer's own
// archive flag — see IOrder.activeState). `'removed'` is an archived draft: that is how a
// draft is removed, so it shows on no tab and in no search result.
export type TOrderListBucket = 'drafts' | 'active' | 'archived' | 'removed'

// The three tabs of the orders list. Every tab but the archived-draft `'removed'` bucket is one.
export type TOrderListTab = Exclude<TOrderListBucket, 'removed'>

export function getOrderListBucket(order: Pick<Order, 'activeState' | 'statuses'>): TOrderListBucket {
  const isDraft = order.statuses.orderStatus === 'draft'
  const isArchived = order.activeState === 'archived'

  if (isDraft) return isArchived ? 'removed' : 'drafts'
  return isArchived ? 'archived' : 'active'
}
